/**
 * API Configuration Layer
 * Manages environment-specific URLs and service paths.
 */

const config = {
  // Detection mode: 'local' or 'production'
  ENV: process.env.REACT_APP_ENV || 'local',

  // Production Gateway (API Gateway base)
  PRODUCTION_GATEWAY: process.env.REACT_APP_PRODUCTION_GATEWAY || "https://performance.onevibe.ai/api/v1",

  // Local direct service URLs (port-based)
  LOCAL_URLS: {
    USER: process.env.REACT_APP_LOCAL_USER_SERVICE || "http://localhost:3002",
    PAYMENT: process.env.REACT_APP_LOCAL_PAYMENT_SERVICE || "http://localhost:3019",
    ADMIN: process.env.REACT_APP_LOCAL_ADMIN_SERVICE || "http://localhost:5200",
    ADMIN_V1: process.env.REACT_APP_LOCAL_ADMIN_SERVICE || "http://localhost:5200",
    ADMIN_V2: process.env.REACT_APP_LOCAL_ADMIN_SERVICE || "http://localhost:5200",
    FEED: process.env.REACT_APP_LOCAL_FEED_SERVICE || "http://localhost:5004",
    FOLLOW: process.env.REACT_APP_LOCAL_FOLLOW_SERVICE || "http://localhost:5005",
    BASE: process.env.REACT_APP_LOCAL_AUTH_SERVICE || "http://localhost:3001",
    ROOT: process.env.REACT_APP_LOCAL_AUTH_SERVICE || "http://localhost:3001",
    AUTH: process.env.REACT_APP_LOCAL_AUTH_SERVICE || "http://localhost:3001",
  },

  // Service path prefixes used ONLY in Production Gateway routing
  PRODUCTION_PREFIXES: {
    USER: "/user",
    USER_V1: "", // api/v1 is already in gateway URL
    PAYMENT: "/payments",
    ADMIN: "/admin",
    ADMIN_V1: "/admin",
    ADMIN_V2: "/api/v2/admin",
    FEED: "/feed",
    FOLLOW: "/follow",
    AUTH: "/auth",
    BASE: "",
    ROOT: "",
  }
};

/**
 * Returns the base URL for a given service.
 * Supports zero-manual-change switching between local and production.
 * 
 * @param {string} serviceName - Key from services mapping
 * @returns {string} The fully qualified base URL for the client
 */
export const getServiceBaseUrl = (serviceName) => {
  const name = serviceName.toUpperCase();

  if (config.ENV === 'local') {
    // Local: Direct service access
    return config.LOCAL_URLS[name] || config.LOCAL_URLS.BASE;
  }

  // Production: Gateway Routing
  const prefix = config.PRODUCTION_PREFIXES[name] || "";
  return `${config.PRODUCTION_GATEWAY}${prefix}`;
};

export default config;
